import React from 'react';
import { Badge } from './ui/badge';
import { Sparkles, Trophy } from 'lucide-react';

export const XPPopup = ({ xp, reason }) => {
  if (!xp) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 animate-xp-pop">
      <Badge className="bg-gamification-xp text-white px-4 py-2 text-lg font-bold shadow-lg">
        <Sparkles className="h-5 w-5 ml-2 animate-spin-slow" />
        +{xp.amount} XP
        {reason && <span className="text-xs font-normal mr-2 opacity-80">({reason})</span>}
      </Badge>
    </div>
  );
};

export const AchievementPopup = ({ achievement }) => {
  if (!achievement) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-2xl p-8 shadow-2xl border border-border/30 text-center max-w-sm mx-4 animate-bounce-in">
        <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-gamification-xp to-gamification-achievement flex items-center justify-center text-4xl shadow-glow animate-float">
          {achievement.icon}
        </div>
        
        <div className="flex items-center justify-center gap-2 mb-2">
          <Trophy className="h-5 w-5 text-gamification-xp" />
          <span className="text-sm font-medium text-gamification-xp">הישג חדש!</span>
        </div>
        
        <h3 className="text-xl font-bold text-foreground mb-1">
          {achievement.name}
        </h3>
        <p className="text-muted-foreground text-sm mb-4">
          {achievement.description}
        </p>
        
        <Badge className="bg-gamification-xp/20 text-gamification-xp border-gamification-xp/30">
          <Sparkles className="h-3 w-3 ml-1" />
          +{achievement.xp} XP
        </Badge>
      </div>
    </div>
  );
};
